import type { CatalogItem, CatalogItemResponse } from '../types';

export function catalogItemMapper(r: CatalogItemResponse): CatalogItem {
  // The Key alone when the response carries no label: a cached page written before the field
  // existed still names its records, and the Key is what the server falls back to anyway.
  return { itemId: r.item_id, values: r.data ?? {}, label: r.label || r.item_id };
}
